import gsap from 'gsap'
import store from '../store'

export default class Showreel {
  constructor() {
    this.bindMethods()
    this.getElems()
    this.events()

    this.open = false

    this.init()
  }

  bindMethods() {
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
  }

  getElems() {
    this.wrapper = document.querySelector('.showreel')
    this.video = this.wrapper.querySelector('video')
    this.close = this.wrapper.querySelector('.showreel__close')
  }

  events() {
    !store.isMobile && document.addEventListener('keydown', (e) => e.key === 'Escape' && this.open && this.hide())
    this.close.addEventListener('click', this.hide)
  }

  init() {
    gsap.set(this.wrapper, { yPercent: 100 })
    gsap.set(this.wrapper, { opacity: 1 })
    store.isMobile && gsap.set(this.wrapper, { opacity: 0 })
  }

  show() {
    if (store.isMobile) {
      this.video.webkitEnterFullscreen()
    } else {
      this.open = true
      store.smoothScroll.stop()

      gsap.to(this.wrapper, {
        yPercent: 0,
        ease: 'expo.out',
        duration: 1,
        onComplete: () => {
          this.video.play()
          this.close.classList.add('a')
        }
      })
    }
  }

  hide() {
    this.open = false
    this.video.pause()
    this.close.classList.remove('a')
    store.smoothScroll.start()

    gsap.to(this.wrapper, {
      yPercent: 100,
      ease: 'expo.out',
      duration: 1
    })
  }
}
